export default "__VITE_ASSET__CWmYmYbL__"